module.exports = __webpack_public_path__ + "img/step-up-camp-web.b1d6114a.png";